







import { Component, Vue, Prop } from 'vue-property-decorator';

import { Comment } from '@/@types/LibraryComponent';

// Component
import DebugUserIcon from '@/components/common/DebugUserIcon.vue';
import CommentItem from '@/components/taskList/taskDetailModal/CommentItem.vue';
import { TaskComment } from '@/@types/Task';

@Component({
  components: {
    CommentItem,
    DebugUserIcon,
  },
})
export default class CommentList extends Vue {
  @Prop({ required: true })
  private commentList!: TaskComment[];

}
